// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2919) return "static/chunks/2919-97d98ed46c3f7461.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4379":"17d5673550bcc208","7785":"861d1223bc8205e9"}[chunkId] + ".js";
};